import { formatNumber } from '@common/utils/numbers';

export const ACTIVITY_METRICS = {
  openrate: {
    label: 'label.OPEN_RATE',
    tooltip: 'label.TOOLTIP.OPEN_RATE',
    formatter: (value) => value.toFixed(0) + '%'
  },
  sent: {
    label: 'label.EMAILS_SENT',
    tooltip: 'label.TOOLTIP.EMAILS_SENT',
    formatter: formatNumber.commas
  },
  uniqueviews: {
    label: 'label.EMAIL_VIEWS',
    tooltip: 'label.TOOLTIP.EMAIL_VIEWS',
    formatter: formatNumber.commas
  },
  totalreach: {
    label: 'label.TOTAL_REACH',
    tooltip: 'label.TOOLTIP.TOTAL_REACH',
    formatter: formatNumber.commas
  },
  uniqueclicks: {
    label: 'label.LINK_CLICKS',
    tooltip: 'label.TOOLTIP.LINK_CLICKS',
    formatter: formatNumber.commas
  },
  uniqueadclicks: {
    label: 'label.AD_CLICKS',
    tooltip: 'label.TOOLTIP.AD_CLICKS',
    formatter: formatNumber.commas
  },
  uniquevisits: {
    label: 'label.WEBSITE_VISITS',
    tooltip: 'label.TOOLTIP.WEBSITE_VISITS',
    formatter: formatNumber.commas
  },
  uniquevideolaunches: {
    label: 'label.VIDEO_VIEWS',
    tooltip: 'label.TOOLTIP.VIDEO_VIEWS',
    formatter: formatNumber.commas
  },
  uniquedocumentlaunches: {
    label: 'label.DOCUMENT_VIEWS',
    tooltip: 'label.TOOLTIP.DOCUMENT_VIEWS',
    formatter: formatNumber.commas
  },
  uniquedocumentdownloads: {
    label: 'label.DOWNLOADS',
    tooltip: 'label.TOOLTIP.DOCUMENT_DOWNLOADS',
    formatter: formatNumber.commas
  },
  uniquebizcardviews: {
    label: 'label.BIZCARD_VIEWS',
    tooltip: 'label.TOOLTIP.BIZCARD_VIEWS',
    formatter: formatNumber.commas
  },
  uniquebizcardscans: {
    label: 'label.BIZCARD_SCANS',
    tooltip: 'label.TOOLTIP.BIZCARD_SCANS',
    formatter: formatNumber.commas
  }
};
